import classes from "./companyShow.module.css";
import { useTranslation } from "react-i18next";
import QRCode from "qrcode.react";
import icons from "../../../../../Data/icons";

const ComapnyDetalis = ({ showComapnies }) => {
  const { t } = useTranslation();

  const IdCardIcon = icons.idCard;
  const AbcIcon = icons.abc;
  const PhoneIcon = icons.phone;
  const FieldIcon = icons.feild;
  const QrIcon = icons.qr;
  const WebsiteIcon = icons.website;
  const EmailIcon = icons.email;
  const titles = {
    id: "#",
    name: t("Name"),
    field: t("Field"),
    Qr: "Qr",
    website: t("website"),
    email: t("email"),
  };

  const { id, name, field, app_key, website, email } = showComapnies;
  const currentTimestamp = Math.floor(Date.now() / 1000);

  return (
    <div className={classes.container}>
      <div class="row user-profile">
        <div class="col-md-6">
          <div class="card">
            <div class="card-body post-about">
            <ul class="list-group">
              <li  class="list-group-item">
                <div class="icon">
                  <IdCardIcon />
                </div>
                <div>
                  <h5 className={classes.listTitle}>{titles.id}</h5>
                  <p>{showComapnies.id}</p>
                </div>
              </li>
              <li  class="list-group-item">
              <div class="icon">
                  <AbcIcon />
                </div>
                <div>
                  <h5 className={classes.listTitle}>{titles.name}</h5>
                  <p className={classes.listPargrah}>{showComapnies.name}</p>
                </div>
              </li>
              <li  class="list-group-item">
                <div class="icon">
                  <PhoneIcon />
                </div>
                <div>
                  <h5 className={classes.listTitle}>{titles.mobile}</h5>
                  <p className={classes.listPargrah}>{showComapnies.mobile}</p>
                </div>
              </li>
              <li  class="list-group-item">
                <div class="icon">
                  <FieldIcon />
                </div>
                <div>
                  <h5 className={classes.listTitle}>{titles.field}</h5>
                  <p className={classes.listPargrah}>{showComapnies.field}</p>
                </div>
              </li>
              <li  class="list-group-item">
                <div class="icon">
                  <WebsiteIcon />
                </div>
                <div>
                  <h5 className={classes.listTitle}>{titles.website}</h5>
                  <p className={classes.listPargrah}>{showComapnies.website}</p>
                </div>
              </li>

              <li  class="list-group-item">
                <div class="icon">
                  <EmailIcon />
                </div>
                <div>
                  <h5 className={classes.listTitle}>{titles.email}</h5>
                  <p className={classes.listPargrah}>{showComapnies.email}</p>
                </div>
              </li>
            </ul>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div className="card">
            <div class="card-body text-center">
              <QRCode
                value={`${id}/${app_key}/${currentTimestamp}`}
                size={400}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComapnyDetalis;
